import { render } from "./FooterSummary.vue?vue&type=template&id=ee8536c8"
import script from "./FooterSummary.vue?vue&type=script&lang=ts"
export * from "./FooterSummary.vue?vue&type=script&lang=ts"
script.render = render

export default script